import { BCErrorBoundary, BCThemeChanger } from '@bimser/components';
import * as React from 'react';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { Mobile } from '../../utilities/MobileView';
import ModalFrameManagerContainer from '../ModalFrameManager/containers';
import ModalManagerContainer from '../ModalManager/containers';
import BCIntlProviderContainer from './BCIntlProviderContainer';
import IProviderProps from './entities/IProviderProps';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

export default class BCProvider extends React.Component<IProviderProps, {}> {
	render() {
		return (
			<HashRouter basename="/">
				<Provider store={this.props.store}>
					<BCIntlProviderContainer>
						<BCThemeChanger environment={this.props.environment}>
							<DndProvider backend={HTML5Backend}>
								<BCErrorBoundary
									mobile={Mobile}
									showHomeBtn
								>
									<ModalManagerContainer
										components={this.props.modalComponents}
									/>
									<ModalFrameManagerContainer />
									{this.props.children}
								</BCErrorBoundary>
							</DndProvider>
						</BCThemeChanger>
					</BCIntlProviderContainer>
				</Provider>
			</HashRouter>
		);
	}
}
